import React from 'react';
import { PropTypes } from 'prop-types';
import { TorgaContext } from '../TorgaContext';
import TaskForm from './TaskForm';
import {
  actionTaskCreate,
  actionTaskDelete,
  actionTaskUpdate,
} from './actions';
import { Button, NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Link, useNavigate } from 'react-router-dom';
import { urlToTaskID } from '../TorgaRouter';

export default function TaskList({ goalID, activityID }) {
  const { state, dispatchAction } = React.useContext(TorgaContext);
  const [selectedTaskID, setSelectedTaskID] = React.useState('');
  const [search, setSearch] = React.useState('');
  const navigate = useNavigate();
  const numericGoalID = Number(goalID);

  const tasks = state.tasks.allIDs
    .map((id) => state.tasks.byID[id])
    .filter((task) => task && !task.deleted)
    .filter((task) => Number(task.goal_id) === numericGoalID);

  const availableTasks = state.tasks.allIDs
    .map((id) => state.tasks.byID[id])
    .filter((task) => task && !task.deleted)
    .filter((task) => Number(task.goal_id) !== numericGoalID)
    .filter((task) => {
      if (!search.trim()) {
        return true;
      }
      return String(task.name || '')
        .toLowerCase()
        .includes(search.toLowerCase());
    });

  return (
    <div>
      <h1>Tasks</h1>
      {tasks.map((task) => (
        <div
          key={task.id}
          style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}
        >
          <Link to={urlToTaskID(task.id)}>{task.name}</Link>
          <Button
            minimal
            icon={IconNames.REMOVE}
            onClick={() => dispatchAction(actionTaskUpdate(task.id, 'goal_id', null))}
          />
          <Button
            minimal
            icon={IconNames.TRASH}
            onClick={() => dispatchAction(actionTaskDelete(task.id))}
          />
        </div>
      ))}

      {tasks.length === 0 && (
        <NonIdealState
          icon={IconNames.TICK}
          description="No tasks linked to this goal yet."
        />
      )}

      <div style={{ marginBottom: 8 }}>
        <input
          type="text"
          placeholder="Search task..."
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          style={{ width: '100%', padding: 8 }}
        />
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <select
          style={{ flex: 1 }}
          value={selectedTaskID}
          onChange={(event) => setSelectedTaskID(event.target.value)}
        >
          <option value="">Link existing task...</option>
          {availableTasks.map((task) => (
            <option key={task.id} value={task.id}>
              T{task.id} - {task.name}
            </option>
          ))}
        </select>
        <Button
          disabled={!selectedTaskID}
          icon={IconNames.ADD}
          onClick={() => {
            dispatchAction(
              actionTaskUpdate(
                Number(selectedTaskID),
                'goal_id',
                Number(goalID)
              )
            );
            setSelectedTaskID('');
          }}
        >
          Associate task
        </Button>
      </div>

      <TaskForm
        onCreate={(task) => {
          dispatchAction(
            actionTaskCreate(
              {
                ...task,
                goal_id: Number(goalID),
                ...(activityID ? { activity_id: activityID } : {}),
              },
              null,
              (createdTask) => {
                navigate(urlToTaskID(createdTask.id), {
                  state: { focusName: true },
                });
              }
            )
          );
        }}
      />
    </div>
  );
}

TaskList.propTypes = {
  goalID: PropTypes.string.isRequired,
  activityID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
